import { Field, ID, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { AddChatMessageArgs } from '../../chat/args/AddChatMessageArgs'
import type { ChatMessage } from '../../chat/Chat'

/**
 * We just need to extend AddChatMessageArgs to include the information related to the orderId
 */
@InputType()
export class AddOrderChatMessageArgs extends AddChatMessageArgs {
  @Field(() => ID)
  orderId: string
}

export interface IAddOrderChatMessage extends IAction<ChatMessage, AddOrderChatMessageArgs> {}
